'use strict';
import extend from 'lodash/extend';

const dataLayer = window.dataLayer = window.dataLayer || [];
const EVENT_TIMEOUT = 2000;

const searchEvent = (action, data) => {
	dataLayer.push(extend({}, data, {
		event: 'GAEvent',
		eventCategory: 'Search',
		eventAction: action,
	}));
}

const checkoutOption = (step, option) => {
	if (step && option) {
		dataLayer.push({
			event: 'checkoutOption',
			ecommerce: {
				checkout_option: {
					actionField: { step, option }
				}
			}
		});
	}
}

export default {
	search: {
		open() {
			searchEvent('Open search ', { eventLabel: '-' });
		},
    
		new(searchTerm) {
			searchEvent('New search ', {
				eventLabel: searchTerm
			});
		},
    
		click(type, linkText, url) {
			const validTypes = {
				suggestion: 'Suggestion',
				product: 'Product',
				store: 'Store',
				link: 'Link'
			};

			const typeLabel = validTypes[type];
			if (!typeLabel) throw new TypeError(`Invalid link type: ${type}`);
      
			const eventData = {
				eventLabel: linkText
			}
			if (url) {
				eventData.eventTimeout = EVENT_TIMEOUT;
				eventData.eventCallback = () => document.location = url;
			}
			searchEvent(`${typeLabel} click `, eventData);
		}
	},

	checkout: {
		selectDeliveryMethod: deliveryMethod => checkoutOption(3, deliveryMethod),
		selectPaymentMethod: paymentMethod => checkoutOption(4, paymentMethod)
	}
}
